export default __webpack_public_path__ + "static/media/309.18a006ba.gif";